/* eslint-disable ember/no-computed-properties-in-native-classes */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';

export default class IndexRoute extends Route {
  @service
  applicationData;

  @service
  features;

  @service
  permissions;

  @service
  router;

  @service
  students;

  @alias('features.controlPanelEnabled')
  controlPanelEnabled;

  activate() {
    this.applicationData.refreshCounts();
    // Check if control panel is enabled before transitioning
    if (this.controlPanelEnabled) {
      this.router.transitionTo('home.control-panel');
    } else {
      this.router.transitionTo('home.daily-notices');
    }
  }
}
